import '../styles/style.css';

export default function Button({title, id, className, onClick}) {

    return <button className={className} id={id} onClick={onClick}>{title}</button>;
    
};